import type { Dispatch } from 'redux';
import type { CampaignState, CampaignAction } from '@/redux/campaign/types';

export enum Actions {
  SetGameIndex = 'SetGameIndex',
  SetGameIndexFail = 'SetGameIndexFail',

  SetCurrentTime = 'SetCurrentTime',
  SetCurrentTimeFail = 'SetCurrentTimeFail',

  SetCampaignData = 'SetCampaignData',
  SetCampaignDataFail = 'SetCampaignDataFail',

  SetCampaignServerTime = 'SetCampaignServerTime',
  SetCampaignServerTimeFail = 'SetCampaignServerTimeFail'
}

export const setGameIndex =
  (index: number) => (dispatch: Dispatch<CampaignAction>) => {
    try {
      dispatch({ type: Actions.SetGameIndex, index });
    } catch (error) {
      dispatch({ type: Actions.SetGameIndexFail, error });
    }
  };

export const setCurrentTime =
  (time: string) => (dispatch: Dispatch<CampaignAction>) => {
    try {
      dispatch({ type: Actions.SetCurrentTime, time });
    } catch (error) {
      dispatch({ type: Actions.SetCurrentTimeFail, error });
    }
  };

export const setCampaignData =
  (data: CampaignState) => (dispatch: Dispatch<CampaignAction>) => {
    try {
      dispatch({ type: Actions.SetCampaignData, data });
    } catch (error) {
      dispatch({ type: Actions.SetCampaignDataFail, error });
    }
  };

export const setCampaignServerTime =
  (time?: string) => (dispatch: Dispatch<CampaignAction>) => {
    try {
      time && dispatch({ type: Actions.SetCampaignServerTime, time });
    } catch (error) {
      dispatch({ type: Actions.SetCampaignServerTimeFail, error });
    }
  };
